import React from 'react'
import intl from 'react-intl-universal'

const Footer = () => (
  <div id="authentication-footer">
    <ul>
      <li><a href="/terms">{intl.get('footer.term')}</a></li>
      <li><a href="/privacy">{intl.get('footer.privacy_policy')}</a></li>
      <li><a href="mailto:quippercampus@quipper.com?subject=User%20Support:%20Inquiry_website">{intl.get('footer.contact')}</a></li>
    </ul>

    <div>©{new Date().getFullYear()} Quipper</div>
    <br />
  </div>
)

export default Footer
